import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoSeguroHyundai from "../segurohyundai/InfoSeguroHyundai";
const Footer = lazy(() => import('../footer/Footer'));
function SeguroHyundai() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Asegura tu Hyundai con los mejores planes en Ecuador. Encuentra coberturas completas y adaptadas a tus necesidades."
        />
        <meta
          name="keywords"
          content="Hyundai, Hyundai Seguros, Seguros Hyundai, Seguros"
        />
        <title>Seguro Hyundai</title>
      </Helmet>
      <Menu />
      <InfoSeguroHyundai />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default SeguroHyundai;